import {
    CButton,
    CTable,
    CTableBody,
    CTableDataCell,
    CTableHead,
    CTableHeaderCell,
    CTableRow
  } from '@coreui/react';
  import React, { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { AppContext } from '../../context/AppContext';
  import styles from './Table.module.css';
import TableCaption from './TableCaption';
import TableFooter from './TableFooter';
  
  
  
  const SubscriptionsTable = ({ columns, data, pagination }) => {

    const navigate = useNavigate();
  
    const {setProductsPageUrl} = useContext(AppContext);
  
    return (
        <>
          <div className="col-12">
          <TableCaption pagination={pagination} noun="suscripciones" />
          <div className={styles.tableCard}>
          <CTable responsive className={styles.styledTable}>
            <CTableHead>
              <CTableRow>
                {columns.map((col, index) => (
                  <CTableHeaderCell key={index} scope="col">
                    {col.label}
                  </CTableHeaderCell>
                ))}
              </CTableRow>
            </CTableHead>
            <CTableBody>
              {data?.map((el, index) => (
                <CTableRow key={index}>
                  <CTableDataCell>{el.id}</CTableDataCell>
                  <CTableDataCell>{el.name}</CTableDataCell>
                  <CTableDataCell>{el.description}</CTableDataCell>
                  <CTableDataCell>${el.price}/{el.payment_frequency}</CTableDataCell>
                  <CTableDataCell>
                    <CButton
                      className={styles.rowActionButton}
                      onClick={() => {
                        navigate(`/dashboard/subscriptions/${el?.id}`);
                      }}
                    >
                      Editar
                    </CButton>
                  </CTableDataCell>
                </CTableRow>
              ))}
            </CTableBody>
          </CTable>
          {!data || data.length === 0 ? (
            <div className={styles.emptyState}>No se encontraron resultados.</div>
          ) : null}
          </div>
          </div>
          <TableFooter range={pagination?.links} setPageUrl={setProductsPageUrl} />
      </>
    );
  };
  
  export default SubscriptionsTable;
  